//
// Generated class InvoiceLine
//

/// <reference path="InvoiceLine_ManagedObject.ts" />

class InvoiceLine extends InvoiceLine_ManagedObject
{
    // NOTE: "tax" and "taxFactor" are not datamodel properties; DBInvoiceLinesCoder assigns them
    // as plain (non-persisted) properties.
    tax: Tax;
    taxFactor: number;
}
